import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducer";
import sagas from "./sagas";

// eslint-disable-next-line import/prefer-default-export
export function configureStore(initialState) {
  
  const sagaMiddleware = createSagaMiddleware({
    onError: (err) => {
      store.dispatch({ type: 'ERROR', payload: err })
    }
  });
  const middlewares = [sagaMiddleware];


  /* eslint-disable no-underscore-dangle */
  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares))
  );

  sagaMiddleware.run(sagas)

  if (module.hot) {
    module.hot.accept("./reducer", () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require("./reducer");
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
